import { useDealForecastStore } from '@openx/components-deal/lib/utils/context/DealForecastContext/DealForecastProvider';
import type { UseDealForecastActions } from '@openx/components-deal/lib/utils/context/DealHookTypes';
import type { DealParticipant } from '@openx/types/deal';
import type { PostForecastDataResponse } from '@openx/types/dealForecasting';
import type { DealForecastContextualEstimate } from '@openx/types/store/deal';
import {
  forecastRequestErrorAction,
  forecastRequestLoadingAction,
  generateForecastButtonDisabledAction,
  getJobIDSuccessAction,
  resetForecastAction,
  updateDealParticipantsAction,
} from '@openx/utils/state/deals/dealForecast/actions';

export const useDealForecastActions: UseDealForecastActions = () => {
  const { dispatch } = useDealForecastStore();

  const updateDealParticipants = (dealParticipants: DealParticipant[]) => {
    dispatch(updateDealParticipantsAction(dealParticipants));
  };

  const setGenerateForecastButtonDisabled = (disabled: boolean) => {
    dispatch(generateForecastButtonDisabledAction(disabled));
  };

  const resetForecast = () => {
    dispatch(resetForecastAction());
  };

  const setForecastJobID = (
    response = { job_id: '', not_included_fields: [] } as PostForecastDataResponse,
    audienceMonthlyRequests: number | null = null,
    contextualEstimate: DealForecastContextualEstimate | null = null
  ) => {
    dispatch(getJobIDSuccessAction(response, audienceMonthlyRequests, contextualEstimate));
  };

  const setForecastLoading = () => {
    dispatch(forecastRequestLoadingAction());
  };

  const setForecastingError = error => {
    dispatch(forecastRequestErrorAction(error));
  };

  return {
    resetForecast,
    setForecastJobID,
    setForecastLoading,
    setForecastingError,
    setGenerateForecastButtonDisabled,
    updateDealParticipants,
  };
};
